export enum StatType {
    Login = "login",
    HealthPlan = "health_plan",
    MealPlan = "meal_plan",
}